import languages from "../layouts/language components/languages/lang.json";

export default function languageTranslator(key, language) {
  const languageCode = language || localStorage.getItem("adtech_lang") || "en";
  return languages[languageCode][key];
}
